<template>
  <div>
    <general-top-bar :title="$t('reports.topProductsReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6" v-if="showLocations">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.products')}}</label>
            <el-select
              v-model="selectedProducts"
              ref="productSelect"
              value-key="id"
              multiple
              filterable
              remote
              collapse-tags
              reserve-keyword
              label="label"
              style="width: 100%"
              :placeholder="$t('reports.searchProducts')"
              :remote-method="searchProducts"
              :loading="loadingProducts"
              @change="clearSearch">
              <el-option
                v-for="item in mergedProducts"
                :key="item.id"
                :label="item.label"
                :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns">
          <chart-bars-card
            v-loading="loading"
            :chart-data="topProductSales.data"
            :chart-options="topProductSales.options"
            ref="topProductSales"
          >
            <template v-if="noData">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
            </div>

            <div slot="footer">
              <div class="chart-legend" style="display: flex; flex-wrap: wrap;">
                <div v-for="item in legendItems" :key="item.product" class="legend-item">
                  <div class="legend-color-box" :style="{ backgroundColor: item.sales.color }"></div>
                  <span>{{ item.sales.label }}</span>

                  <div class="legend-color-box" :style="{ backgroundColor: item.discount.color }"></div>
                  <span>{{ item.discount.label }}</span>
                </div>
              </div>
            </div>
          </chart-bars-card>
        </div>
      </div>

      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="80" prop="product_name" :label="$t('reports.product')" />
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_quantity" :label="$t('reports.quantity')">
              <template slot-scope="props">
                {{ Number(props.row.total_quantity) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_sales" :label="$t('reports.revenue')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_discount" :label="$t('reports.discount')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_discount)) }}
              </template>
            </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isTopProducts: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTopProducts () {
      if (this.isTopProducts) {
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
      }
    }
  },
  // created () {
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  // },
  computed: {
    mergedProducts () {
      const map = new Map(this.availableProducts.map(t => [t.id, t]))
      this.selectedProducts.forEach(t => {
        if (!map.has(t.id)) {
          map.set(t.id, t)
        }
      })
      return Array.from(map.values())
    }
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedProducts: [],
      availableProducts: [],
      allProductsMap: new Map(),
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true,
            offset: 20
          }
        }
      },
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      loadingProducts: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      legendItems: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {},
      totalOrders: null,
      colors: [
        '#f44336', // red
        '#2196f3', // blue
        // '#4caf50', // green
        '#ff9800', // orange
        '#9c27b0', // purple
        '#00bcd4', // cyan
        // '#e91e63', // pink
        '#8bc34a', // light green
        '#ffc107', // amber
        '#3f51b5', // indigo
        '#ff5722', // deep orange
        '#795548', // brown
        '#607d8b', // blue grey
        '#009688', // teal
        '#cddc39', // lime
        '#673ab7', // deep purple
        '#03a9f4', // light blue
        '#aed581', // soft green
        '#ffb74d', // soft orange
        '#ba68c8'  // soft purple
      ],
      noData: false
    }
  },
  methods: {
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isTopProducts) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        payment_method: this.selected_payment_method
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(table => table.id)
      }

      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      // const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
      const hasReceiptValue = (this.hasRceipt && this.hasRceipt.value) || null

      this.apiRequest('/reports/v2/top-products' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, response => {
        if (response.status) {
          if (response.data.table_data.length) {
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.pagination.total
            this.paginationProps.currentPage = response.pagination.page
            this.paginationProps.pageSize = response.pagination.perPage
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
          }

          this.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 40
          }

          if (!response.data.products.length) {
            this.$nextTick(() => {
              this.topProductSales.data.labels = []
              this.topProductSales.data.series = [[]]
              this.discounts = []
              this.noData = true

              if (this.$refs.topProductSales.chart) {
                this.$refs.topProductSales.initChartAndReturn()
              }

              return false
            })
          }

          this.noData = false

          const baseLabels = []
          const salesSeries = []
          const discountsSeries = []

          response.data.products.forEach((product, index) => {
            baseLabels.push(product)
            salesSeries.push(response.data.sales[index] || 0)
            discountsSeries.push(response.data.discounts[index] || 0)
          })

          this.topProductSales.data.labels = baseLabels
          this.topProductSales.data.series = [salesSeries, discountsSeries]

          this.discounts = response.data.discounts

          this.legendItems = this.topProductSales.data.labels.map((product, index) => {
            const baseColor = this.colors[index % this.colors.length]
            return {
              product,
              sales: {
                label: `${product} - ${this.topProductSales.data.series[0][index]}`,
                color: baseColor
              },
              discount: {
                label: `Discount ${product} - ${this.topProductSales.data.series[1][index] || 0}`,
                color: this.lightenHexColor(baseColor, 40)
              }
            }
          })

          this.$nextTick(() => {
            this.$refs.topProductSales.initChartAndReturn()

            if (this.$refs.topProductSales.chart) {
              this.$refs.topProductSales.chart.on('draw', data => {
                if (data.type === 'bar') {
                  const productIndex = data.index
                  const isDiscount = data.seriesIndex === 1
                  const baseColor = this.colors[productIndex % this.colors.length]
                  const color = isDiscount ? this.lightenHexColor(baseColor, 40) : baseColor

                  data.element.attr({
                    style: `stroke: ${color}; stroke-width: 30px;`
                  })
                }
              })
            }
          })
        } else {
          this.topProductSales.data.labels = []
          this.topProductSales.data.series = [[]]
          this.discounts = []
          this.noData = true

          if (this.$refs.topProductSales.chart) {
            this.$refs.topProductSales.initChartAndReturn()
          }

          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    lightenHexColor (hex, percent) {
      let num = parseInt(hex.replace('#', ''), 16)
      let amt = Math.round(2.55 * percent)
      let R = (num >> 16) + amt
      let G = (num >> 8 & 0x00FF) + amt
      let B = (num & 0x0000FF) + amt

      return '#' + (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      ).toString(16).slice(1)
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        payment_method: this.selected_payment_method,
        has_receipt: (this.hasRceipt && this.hasRceipt.value) || null
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(table => table.id)
      }

      this.loading = true
      this.apiRequest('/reports/v2/top-products-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    },
    clearSearch () {
      this.$refs.productSelect.focus()
      const select = this.$refs.productSelect

      if (select) {
        select.query = ''
        select.handleQueryChange('')
      }
    },
    searchProducts (query) {
      if (!query) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loadingProducts = true

      this.apiRequest('/search-order-products', 'GET', data, response => {
        if (response.status) {
          response.data.forEach(item => {
            this.allProductsMap.set(item.id, item)
          })

          this.availableProducts = response.data
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loadingProducts = false
        })
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .legend-color-box {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 5px;
    margin-left: 5px;
    border-radius: 7px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/TopProducts.vue